import fetch from 'isomorphic-fetch';
import { SHOPS_BY_IDS, OFFERS_BY_IDS } from '../queries/queryConstants';
import { BASE_SITE_URL } from './constants';

// Returns a promise where the data is in `res.data.shopsByIds`
export const apiQueryShopsByIds = (ids, locale, httpBase = '') => {
  if (!ids) return null;

  const fetchOptions = {
    method: 'post',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify({
      query: SHOPS_BY_IDS,
      variables: {
        ids,
      },
    }),
  };

  const fetchUrl = `${httpBase}/api/${locale}/graphql/apiQueryShopsByIds`;

  return fetch(fetchUrl, fetchOptions).then((res) => {
    if (res.status === 200) {
      return res.json();
    }
    if (res.err) {
      return Promise.reject(res.err);
    }
    return Promise.reject(res);
  });
};

// Returns a promise where the data is in `res.data.offersByIds`
export const apiQueryOffersByIds = (ids, locale, httpBase = '') => {
  // cannot return null and call 'then' - need to fix
  if (!ids) return null;

  const fetchOptions = {
    method: 'post',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify({
      query: OFFERS_BY_IDS,
      variables: {
        ids,
      },
    }),
  };

  const fetchUrl = `${httpBase}/api/${locale}/graphql/apiQueryOffersByIds`;

  return fetch(fetchUrl, fetchOptions).then((res) => {
    if (res.status === 200) {
      return res.json();
    }

    return Promise.reject(res);
  });
};

const baseSiteUrl = () => {
  return BASE_SITE_URL ?? 'https://earnmore.bluerewards.ca';
};

export const apiSearchAlgolia = (searchQuery, searchOptions, indexType, locale) => {
  const url = baseSiteUrl();

  return fetch(`${url}/${locale}/api/searchAlgolia`, {
    method: 'POST',
    credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      indexType,
      searchOptions,
      searchQuery,
    }),
  })
  .then(res => res.json());
};

export const apiSearchForFacetsAlgolia = (categoryFacetSearchOptions, indexType, locale) => {
  const url = baseSiteUrl();

  return fetch(`${url}/${locale}/api/searchForFacetAlgolia`, {
    method: 'POST',
    credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      indexType,
      categoryFacetSearchOptions,
    }),
  })
  .then(res => res.json());
};
